/**
 * Ancho de columna para celdas con solo icono en SimpleCustomTable.
 * Móvil: ancho suficiente para Button contained + padding de celda (evita solaparse);
 * `wrapText: false` evita `overflow: hidden` del `wrapCellContent` global.
 * Escritorio: columna compacta.
 */
export function iconActionColumnSizing(isMobile: boolean) {
  if (isMobile) {
    return {
      width: '52px',
      minWidth: '52px',
      maxWidth: '52px',
      align: 'center' as const,
      wrapText: false,
    } as const;
  }
  return {
    width: '52px',
    minWidth: '52px',
    maxWidth: '52px',
    align: 'center' as const,
    wrapText: false,
  } as const;
}

/** Tamaño estándar del botón con icono en celdas de SimpleCustomTable. */
export const simpleTableIconButtonSx = {
  minWidth: '28px',
  width: '28px',
  height: '28px',
  padding: '2px',
  boxSizing: 'border-box',
} as const;
